import { inject } from '@angular/core'
import { Router, UrlTree } from '@angular/router'

import { RateType } from '@enums/rate-type'
import { TicketActionsState } from '@states/ticket-actions'
import { TicketInfoState } from '@states/ticket-info'
import { UrlParametersState } from '@states/url-parameters'

export const paymentGuard = (): boolean | UrlTree => {
	const router = inject(Router)
	const urlParametersState = inject(UrlParametersState)
	const ticketInfoState = inject(TicketInfoState)
	const ticketActionsState = inject(TicketActionsState)
	const urlParameters = urlParametersState.urlParameters()
	const ticketInfo = ticketInfoState.ticketInfo()
	const configuration = ticketActionsState.configuration()

	if (!urlParameters || !ticketInfo || !configuration) {
		return router.createUrlTree(['/common/error'])
	}

	if (ticketInfo.rate?.id === RateType.Overnight && ticketInfo.rate?.partnerProcessPayments) {
		const { uuid, ticket } = urlParameters

		return router.createUrlTree(['/ticket', uuid, ticket])
	}

	return true
}
